import { Auth } from "aws-amplify";
import { getEncryptDataFromPath } from "../utils";
import { processConfig as process } from "./env";

export const config = {
  API: {
    endpoints: [
      {
        name: process.env.WEB_API_NAME,
        endpoint: process.env.WEB_API_ENDPOINT,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          };
        },
      },
      {
        name: process.env.BACK_API_NAME,
        endpoint: process.env.BACK_API_ENDPOINT,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          };
        },
      },
      {
        name: process.env.BACK_API_NAME_V2,
        endpoint: process.env.BACK_API_ENDPOINT_V2,
        custom_header: async () => {
          try {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            };
          } catch (error) {
            return {};
          }
        },
      },
      {
        name: process.env.BACK_API_NOAUTH_NAME,
        endpoint: process.env.BACK_API_ENDPOINT,
      },
      // {
      //   name: "Test",
      //   endpoint:
      //     "https://fgsm94y2k0.execute-api.us-west-1.amazonaws.com/prod",
      // },
    ],
  },
  Auth: {
    region: process.env.AWS_REGION,
    userPoolId: process.env.AMPLIFY_USER_POOL_ID,
    identityPoolId: process.env.AMPLIFY_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  },
  Storage: {
    bucket: process.env.S3_BUCKET_ARCHFORM_PATIENT_DATA_V2,
    region: process.env.AWS_REGION,
    identityPoolId: process.env.AMPLIFY_IDENTITY_POOL_ID,
  },
  // Cache: {
  //   itemMaxSize: 4999999,
  //   capacityInBytes: 5000000,
  // },
};

export const readonly_config = {
  Auth: {
    region: process.env.AWS_REGION,
    userPoolId: process.env.AMPLIFY_USER_POOL_ID,
    identityPoolId: process.env.AMPLIFY_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  },
  Storage: {
    bucket: process.env.S3_BUCKET_ARCHFORM_PATIENT_DATA_V2,
    region: process.env.AWS_REGION,
    identityPoolId: process.env.AMPLIFY_IDENTITY_POOL_ID,
  },
};
